import { render, staticRenderFns } from "./OtpVerification.vue?vue&type=template&id=1730d7e0&scoped=true&"
import script from "./OtpVerification.vue?vue&type=script&lang=js&"
export * from "./OtpVerification.vue?vue&type=script&lang=js&"
import style0 from "./OtpVerification.vue?vue&type=style&index=0&id=1730d7e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1730d7e0",
  null
  
)

export default component.exports